import ax from "./ax";
import axParam from "./axParam";

export function GetTokenBySh() {
  return ax({
    url: "api/Login/GetToken",
    method: "post",
  });
}

export function GetTokenByDls() {
  return ax({
    url: "app/User/GetToken",
    method: "post",
  });
}

export function GetConfigBySh() {
  return ax({
    url: "api/Login/GetConfig",
    method: "post",
  });
}

export function GetConfigByDls() {
  return ax({
    url: "app/User/GetConfig",
    method: "post",
  });
}

export function GetMobileVerificationCode(data = {}) {
  return ax({
    url: "api/Login/GetMobileVerificationCode",
    method: "post",
    data,
  });
}

export function GetSMSCode(data = {}) {
  return ax({
    url: "app/User/GetSMSCode",
    method: "post",
    data,
  });
}

export function RegUser(data = {}) {
  return ax({
    url: "api/Login/" + PUBLIC_INTERFACE.addUser,
    method: "post",
    data,
  });
}

export function AddUser(data = {}) {
  return ax({
    url: "app/User/" + PUBLIC_INTERFACE.addUser,
    method: "post",
    data,
  });
}

export function GetCityCode(data = {}) {
  return ax({
    url: "api/UserInfo/GetCityCode",
    method: "post",
    data,
  });
}

export function GetMobileVerificationCodeByParam(token, url, data = {}) {
  return axParam({
    url: url,
    method: "post",
    headers: { "token": token },
    data: data,
  });
}

export function RegUserByParam(token, url, data = {}) {
  return axParam({
    url: url,
    method: "post",
    headers: { "token": token },
    data: data,
  });
}

//OcrApi / GetIdNameFaceServiceUrl
export function GetIdNameFaceServiceUrl(data = {}) {
  return ax({
    url: "api/OcrApi/GetIdNameFaceServiceUrl",
    method: "post",
    data,
  });
}
